<template>
  <div class="modal fade" id="warning" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-gradient-danger" id="warningModalHeader">
          <h5 class="modal-title" id="warningModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>آیا از حذف {{ section.title }} اطمینان دارید؟!</h4>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-success" data-bs-dismiss="modal">خیر</button>
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal"
            @click="deleteSection">حذف</button>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-body">
        <div>
          <div v-if="getPermission(1020).view" class="col-md-4">
            <label class="form-control-label required" for="companyTitle">لطفا شرکت مد نظر خود را انتخاب کنید</label>
            <treeselect v-model="companyId" :multiple="false" placeholder="انتخاب کنید" :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است" :options="companies" />
          </div>
        </div>
        <div>
          <hr class="horizontal dark" />
        </div>
        <div class="table-responsive p-0">
          <table class="table table-striped table-styled table-sm">
            <thead>
              <tr>
                <th>#</th>
                <th>نام بخش</th>
                <th>پیش فرض ثبت تیکت</th>
                <th>مکالمات محرمانه</th>
                <th>نمایش به مشتریان</th>
                <th>بخش ویژه</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr v-for="(cs, index) in sections" :key="cs.id">
                <td scope="row">{{ index + 1 }}</td>
                <td>{{ cs.title }}</td>
                <td>
                  <div class="d-inline-flex text-white p-1 table-check bg-success" v-if="cs.isTicketingDefault">
                    <i class="ni ni-check-bold" />
                  </div>
                </td>
                <td>
                  <div class="d-inline-flex text-white p-1 table-check bg-success" v-if="cs.hasConfidentialConversations">
                    <i class="ni ni-check-bold" />
                  </div>
                </td>
                <td>
                  <div class="d-inline-flex text-white p-1 table-check bg-success" v-if="cs.isShownToCustomers">
                    <i class="ni ni-check-bold" />
                  </div>
                  <div class="d-inline-flex text-white p-1 table-check bg-danger" v-else>
                    <i class="ni ni-fat-remove" />
                  </div>
                </td>
                <td>
                  <div class="d-inline-flex text-white p-1 table-check bg-success" v-if="cs.isSpecial">
                    <i class="ni ni-check-bold" />
                  </div>
                </td>
                <td>
                  <button v-if="cs.isSpecial & (getPermission(1020).view | getPermission(1100).view)"
                    class="btn btn-sm bg-gradient-primary mb-0"
                    @click="goToManageCustomers(cs.id, cs.title, cs.companyId, cs.companyTitle)"
                    title="مدیریت دسترسی مشتریان به بخش">
                    <fa-icon icon="fas fa-shop" />
                  </button>
                  <button v-if="getPermission(1020).update | getPermission(1100).update"
                    class="btn btn-sm bg-gradient-warning mb-0" @click="goToEdit(cs.id)" title="ویرایش">
                    <fa-icon icon="fas fa-pencil" />
                  </button>
                  <button v-if="getPermission(1020).update | getPermission(1100).update"
                    class="btn btn-sm bg-gradient-info mb-0"
                    @click="goToManageCompanyReferrals(cs.companyId, cs.id)"
                    title="مدیریت کاربران دریافت کننده تیکت به ازای هر مشتری">
                    <fa-icon icon="fas fa-user-tag" />
                  </button>
                  <button v-if="getPermission(1020).delete | getPermission(1100).delete"
                    class="btn btn-sm bg-gradient-danger mb-0" @click="setSection(cs)" data-bs-toggle="modal"
                    data-bs-target="#warning" title="حذف">
                    <fa-icon icon="fas fa-trash" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <hr class="horizontal dark" />
        </div>
        <div>
          <button v-if="getPermission(1020).insert | getPermission(1100).insert" class="btn bg-gradient-success mb-0"
            @click="goToAdd">افزودن بخش جدید</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/Company/Company-service.js';
import Treeselect from '@cholakovdev/vue3-treeselect';
import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  data() {
    return {
      sections: [],
      section: {},
      title: '',
      companies: [],
      company: {},
      companyId: null
    };
  },
  computed: {
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId(company) {
      if (company > 0) { this.getSections(); }
      else { this.sections = []; }
      //setTimeout(() => this.getCompanies(), 100);
    }
    //company(company) {
    //  if (company) {
    //    if (company.id) {
    //      this.getSections()
    //    }
    //    else {
    //      this.sections = [];
    //    }
    //  }
    //  else {
    //    this.sections = [];
    //  }
    //}
  },
  methods: {
    getCompanies() {
      CompanyService.getCompanyList().then(response => {
        let result = response.data;

        if (!result.success) {
          this.$toast.error(result.message);
        }
        else {
          this.companies = result.data;
        }
      }).catch(e => {
        console.log(e);
      })
    },
    getSections() {
      CompanyService.getCompanySections(this.companyId).then(response => {
        let result = response.data;

        if (!result.success) {
          this.$toast.error(result.message);
        }
        else {
          this.sections = result.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    setSection(section) {
      this.section = section;

      this.title = this.section.title;
    },
    submit() {
      let newSection = {
        Title: this.title,
        CompanyId: this.company.id
      }
      if (this.section.id) {
        let editedSection = {
          Id: this.section.id,
          CompanySectionId: this.company.id,
          Title: this.title
        };
        CompanyService.updateSection(editedSection).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.$toast.success(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        CompanyService.addSection(newSection).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.$toast.success(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      setTimeout(() => this.getSections(), 500);
    },
    deleteSection() {
      let sectionId = this.section.id;

      CompanyService.deleteSection(sectionId).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);

          let index = this.sections.indexOf(this.section);
          this.sections.splice(index, 1);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    goToAdd() {
      if (this.companyId > 0) {
        this.$router.push('/addSection/' + this.companyId);
      }
      else {
        this.$router.push('/addSection/0');
      }
    },
    getCompany() {
      CompanyService.getCompany(this.$route.params.companyId).then(response => {
        let result = response.data;

        if (result.success) {
          this.company = result.data;
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    goToEdit(sectionId) {
      this.$router.push('/updateSection/' + sectionId);
    },
    goToManageCustomers(sectionId, sectionTitle, companyId, companyTitle) {
      this.$router.push({ path: '/manageSectionCustomers', query: { sectionId, sectionTitle, companyId, companyTitle } });
    },
    goToManageCompanyReferrals(companyId, sectionId) {
      this.$router.push({ path: '/CustomerReferTargetManager', query: { companyId, sectionId } });
    },
  },
  created() {
    this.companies.push(this.$store.state.currentUserInfo.companies);
    //this.companyId = this.$store.state.currentUserInfo.companies.id;
    //setTimeout(() => console.log(this.companies), 1000);
    if (this.$route.params.companyId > 0) {
      this.companyId = this.$route.params.companyId;
    }
    else {
      this.companyId = this.$store.state.currentUserInfo.companyId;
    }
  }
}
</script>